import { Tag } from 'lucide-react';
import { useState } from 'react';

interface SitePromo {
  id: string;
  icon?: string;
  title: string;
  description?: string;
  expiresAt?: string;
}

interface PromoBannerProps {
  promos?: SitePromo[];
}

interface PromoBannerRowProps {
  promo: SitePromo;
}

function PromoBannerRow({ promo }: PromoBannerRowProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="flex items-start gap-3 px-4 py-3">
      {/* Icon */}
      <div
        className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg text-base"
        style={{ backgroundColor: 'var(--brand-orange-soft)' }}
      >
        {promo.icon ? (
          <span role="img" aria-hidden="true">
            {promo.icon}
          </span>
        ) : (
          <Tag className="h-4 w-4" style={{ color: 'var(--brand-orange)' }} />
        )}
      </div>

      {/* Text */}
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-900">{promo.title}</p>
        {promo.description && <p className={`text-muted-foreground mt-0.5 text-xs ${expanded ? '' : 'line-clamp-1'}`}>{promo.description}</p>}
      </div>

      {/* Chevron toggle */}
      {promo.description && (
        <button
          onClick={() => setExpanded((v) => !v)}
          className="flex-shrink-0 text-gray-400 transition-transform duration-200 hover:text-gray-600"
          style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          aria-label={expanded ? 'Thu gọn' : 'Xem thêm'}
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      )}
    </div>
  );
}

export function PromoBanner({ promos }: PromoBannerProps) {
  if (!promos?.length) return null;

  return (
    <div
      className="mb-4 divide-y rounded-xl border bg-white"
      style={{
        borderColor: 'var(--pill-border)',
        // @ts-ignore — CSS custom property on divider
        '--tw-divide-color': 'var(--pill-border)',
      }}
    >
      {promos.map((promo) => (
        <PromoBannerRow key={promo.id} promo={promo} />
      ))}
    </div>
  );
}
